const galleryImages = document.getElementsByClassName("fomo-gallery-image-item");

if(galleryImages.length > 0){
  for(let i = 0, c = galleryImages.length; i<c; i++){
    galleryImages[i].addEventListener("click", function(event){
      const sectionId = event.target.dataset.section;
      const sectionElement = document.getElementById(`section-${sectionId}`);
      const currentSelected = sectionElement.querySelectorAll('.fomo-image-text-container .selected');
      for(let ii = 0, cc = currentSelected.length; ii < cc; ii++){
        currentSelected[ii].classList.remove("selected");
      }
      const index = event.target.dataset.index;
      
      sectionElement.getElementsByClassName(`fomo-gallery-image-${ index }`)[0].classList.add("selected");
      sectionElement.getElementsByClassName(`fomo-text-${ index }`)[0].classList.add("selected");
      sectionElement.querySelector('#fomo-gallery-target').src = event.target.src;
    });
    
  }
}